module.exports = __webpack_public_path__ + "img/share-link-normal.40b2a0ea.svg";